module.exports = "<ion-item>\r\n  An Outcome is a unit of work which a learner can achieve.\r\n</ion-item>"